<template>
  <div>
    <div id="app">
      <b-container class="con">
        <b-card no-body>
          <b-card-header class="bg-white" id="myHeader">
            <b-row>
              <b-col cols="2">
                <span style="font-size: 22px">
                  <strong class="text-primary">{{ $t("Testlar ro'yxati") }}</strong>
                </span>
              </b-col>
              <b-col cols="6">
                <vue-select
                  style="width: 100%"
                  class="style-choose"
                  :label="$localeKey()"
                  :options="questionTypeList"
                  v-model="depsId"
                  :reduce="(el) => el.id"
                >
                  <template #no-options>
                    {{ $t("warning.noInformation") }}
                  </template>
                </vue-select>
              </b-col>
              <b-col cols="4">
                <div style="float: right">
                  <b-button-group v-if="!isCheck" size="md">
                    <b-button @click.prevent="$emit('create')" variant="primary">
                      <i class="fa fa-plus"></i>
                      {{ $t("actions.add") }}
                    </b-button>
                    <!-- <b-button variant="outline-primary">
                      <i class="fa fa-edit"></i>
                      {{$t('actions.edit')}}
                    </b-button> -->
                    <b-button variant="danger" @click="isCheck = true">
                      <i class="fa fa-trash"></i>
                      {{ $t("actions.delete") }}
                    </b-button>
                    <b-button
                      v-show="!isSearch"
                      variant="outline-info"
                      @click="isSearch = !isSearch"
                    >
                      <i class="fa fa-search"></i>
                      {{ $t("search") }}
                    </b-button>
                  </b-button-group>

                  <b-button-group v-if="isCheck">
                    <b-button variant="outline-danger" @click="deleteItems">
                      <i class="fa fa-check"></i>
                      {{ $t("Tanlanganlarni o`chirish") }}
                    </b-button>
                    <b-button variant="outline-primary" @click="cancel">
                      <i class="fa fa-times"></i>
                      {{ $t("actions.cancel") }}
                    </b-button>
                  </b-button-group>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-input-group
                v-show="isSearch"
                size="xl"
                class="m-3"
                style="border: 1px solid rgb(137, 80, 252); border-radius: 5px"
              >
                <b-form-input
                  size="lg"
                  v-model="searchQuestion"
                  :placeholder="$t('search')"
                  type="search"
                ></b-form-input>
                <b-input-group-append style="z-index: 0">
                  <b-button size="xl" variant="outline-info" @click="isSearch = false">
                    <i class="fa fa-times"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-row>

            <hr />
            <div class="text-center mt-3 ml-2">
              <b-pagination
                size="sm"
                class="m-0"
                :total-rows="total"
                :per-page="limit"
                v-model="page"
                :prev-text="$t('actions.prev')"
                :next-text="$t('actions.next')"
                hide-goto-end-buttons
              />
            </div>
          </b-card-header>
          <b-card-body class="p-1" v-if="!loader">
            <loading :active.sync="loader" :is-full-page="false" loader="bars"></loading>
            <h4 class="text-center mt-2 mb-4" v-if="isCheck">
              <span class="text-danger">{{
                $t("O'chiriladigan testlarni tanlang")
              }}</span>
            </h4>

            <div
              @click.prevent="pushTest(item.id)"
              class="m-2 p-3"
              :class="[
                isCheck ? 'bg-light' : '',
                selectedTest.indexOf(item.id) > -1 ? 'selectedClass' : '',
              ]"
              v-for="(item, index) in list"
              :key="index"
            >
              <div style="display: flex; justify-content: space-between">
                <h5 class="mb-3">
                  {{ item[$localeKey()] }}
                </h5>
                <div>
                  <i
                    @click="$emit('edit-selected', item)"
                    style="cursor: pointer"
                    class="fas fa-edit text-primary"
                  ></i>
                </div>
              </div>
              <div
                style="display: block"
                v-for="(choice, i) in item.answers"
                :key="i + 'index'"
              >
                <input
                  :checked="choice.isAnswer"
                  :disabled="!choice.isAnswer"
                  type="radio"
                />
                <label class="ml-3"> {{ choice[$localeKey()] }}</label>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </b-container>
    </div>
  </div>
</template>

<script>
import vacancyService from "@/services/vacancy.service";
import Loading from "vue-loading-overlay";
// import YurDepartments from "./dep/withRequesiteDep";
import "vue-loading-overlay/dist/vue-loading.css";
import { mapActions, mapState } from "vuex";
import QuestTypeService from "@/services/reference/question-type.service";

export default {
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  watch: {
    isSearch: {
      async handler() {
        this.searchQuestion = "";
      },
    },
    page: {
      async handler() {
        await this.getList();
        setTimeout(() => {
          if (this.pageYOffset > 300) {
            window.scrollTo(0, this.pageYOffset);
          }
        }, 200);
      },
    },
    limit: {
      async handler() {
        await this.getList();
      },
    },
    searchQuestion: {
      async handler() {
        await this.getList();
      },
    },

    depsId: {
      async handler(value) {
        await this.$store.commit("testcrud/setSelectedDepsId", value);
        this.getList();
      },
    },
  },
  components: {
    Loading,
    // YurDepartments
  },
  data() {
    return {
      isSearch: false,
      searchQuestion: "",
      depsId: null,
      selectedRadio: true,
      pageYOffset: 0,
      isCheck: false,
      page: 1,
      limit: 20,
      list: [],
      listDep: [],
      relevantQestion: [
        { value: "DXA", text: "Davlat xizmatlari agentligi" },
        { value: "AV", text: "Adliya vazirligi" },
        { value: "YURTEX", text: "Yuridik texnikum" },
        { value: "AKT", text: "Axborot kommunikatsiya texnologiyalari" },
      ],
      total: 0,
      loader: false,
      selectedTest: [],
      questionTypeList: [],
    };
  },
  computed: {
    ...mapState("testcrud", ["selectedDepsId"]),
    params() {
      return {
        page: this.page - 1,
        limit: this.limit,
      };
    },
  },
  methods: {
    ...mapActions("testcrud", { "": "" }),
    async getQuesTypes() {
      let res = await QuestTypeService.getList();
      this.questionTypeList = res.data;
    },
    async fetch(search, loading) {
      this.search.title = search;
      await this.getpassportSeriaList(this.params);
    },
    handleScroll() {
      var header = document.getElementById("myHeader");
      if (header) {
        var sticky = header.offsetTop;
        if (window.pageYOffset > sticky + 200) {
          header.classList.add("stickyHead");
          this.pageYOffset = window.pageYOffset;
        } else {
          header.classList.remove("stickyHead");
          this.pageYOffset = window.pageYOffset;
        }
      }
    },
    deleteItems() {
      this.$bvModal
        .msgBoxConfirm(this.$t("actions.delete"), {
          title: this.$t("login.verify"),
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          okTitle: this.$t("actions.yes"),
          cancelTitle: this.$t("actions.no"),
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            this.loader = true;
            this.selectedTest.forEach(async (element) => {
              vacancyService.deleteQuestion(element);
            });
            this.selectedTest = [];
            this.loader = false;
            this.isCheck = false;
            setTimeout(async () => {
              await this.getList(this.params);
            }, 300);
          }
        });
    },
    pushTest(id) {
      if (this.isCheck) {
        let index = this.selectedTest.indexOf(id);
        if (index > -1) {
          this.selectedTest.splice(index, 1);
        } else {
          this.selectedTest.push(id);
        }
      } else {
        return;
      }
    },
    cancel() {
      this.selectedTest = [];
      this.isCheck = false;
    },
    getListDep() {
      vacancyService.getListDep().then((res) => {
        this.list = res.data;
      });
    },
    getList() {
      this.loader = true;
      let dataobj = {
        typeId: this.depsId,
        search: this.searchQuestion,
      };
      vacancyService.getTestList(dataobj, this.params).then((res) => {
        if (res.data) {
          this.list = res.data.list;
          this.total = res.data.total;
          this.loader = false;
        }
      });
    },
    // getListDep() {
    //   this.loader = true;
    //   vacancyService.getListDep().then( res => {
    //     if (res.data) {
    //       this.listDep = res.data;
    //     }
    //   } );
    // },
  },
  async created() {
    this.getQuesTypes();
    // this.depsId = this.selectedDepsId
    await this.getList();
    // await this.getListDep();
    window.addEventListener("scroll", this.handleScroll);
  },
};
</script>

<style>
.selectedClass {
  background: rgb(216, 89, 89) !important;
  color: white;
}

.selectedClass p {
  color: white !important;
}

.stickyHead {
  padding: 12px !important;
  border-radius: 0px;
  left: 0;
  right: 0;
  position: fixed;
  top: 0;
  background: white;
  z-index: 96;
  border-bottom: 4px solid #4a7dff;
}

.bgcolors {
  color: #4a7dff;
}
</style>
